import { render, staticRenderFns } from "./ConsentForClinicalObservation.vue?vue&type=template&id=06a63f9b"
import script from "./ConsentForClinicalObservation.vue?vue&type=script&lang=js"
export * from "./ConsentForClinicalObservation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports